import translations from './translations'

translations.add('pt', {
    headerMessage: 'Tem a certeza de que deseja cancelar?',
    no: 'NÃO',
    yes: 'SIM'
})
